module.exports = __webpack_public_path__ + "img/community_bg1.8089bb5a.png";